import React from 'react';
import { UserCheck, UserX } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// played: true = Played, false = DNP (Did Not Play), null = back to auto-detect.
export async function setPlayerPlayed(gameId, playerId, played) {
  const token = localStorage.getItem('session_token');
  const res = await fetch(`${API_URL}/api/stats/games/${gameId}/players/${playerId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ played }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || 'Could not update player');
  }
}

export async function fetchParticipation(gameId) {
  const res = await fetch(`${API_URL}/api/stats/games/${gameId}/participation`);
  if (!res.ok) return {};
  return (await res.json()).players || {};
}

export const PlayedToggle = ({ played, onToggle, testId }) => (
  <button
    type="button"
    onClick={onToggle}
    className={`shrink-0 inline-flex items-center gap-1 h-9 px-2.5 rounded-md text-[11px] font-bold uppercase tracking-wider border transition-colors ${
      played
        ? 'bg-emerald-500/15 border-emerald-400/50 text-emerald-300 hover:bg-emerald-500/25'
        : 'bg-white/5 border-white/15 text-white/50 hover:bg-white/10'}`}
    title={played ? 'Counts toward games played. Tap to mark DNP.' : 'Did not play. Tap to mark as played.'}
    data-testid={testId}
  >
    {played ? <UserCheck className="w-3.5 h-3.5" /> : <UserX className="w-3.5 h-3.5" />}
    {played ? 'Played' : 'DNP'}
  </button>
);

export const DnpList = ({ players, onMarkPlayed, teamKey }) => {
  if (!players?.length) return null;
  return (
    <div className="px-4 py-3 border-t border-slate-200 bg-slate-50/60" data-testid={`dnp-list-${teamKey}`}>
      <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-2">
        Did not play ({players.length}) · only you can see this
      </div>
      <div className="flex flex-wrap gap-2">
        {players.map(p => (
          <span key={p.player_id} className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full pl-3 pr-1 py-1 text-xs text-slate-600">
            #{p.jersey} {p.name}
            <button
              type="button"
              onClick={() => onMarkPlayed(p.player_id)}
              className="rounded-full bg-emerald-50 text-emerald-700 hover:bg-emerald-100 px-2 py-0.5 font-semibold"
              data-testid={`dnp-mark-played-${p.player_id}`}
            >
              Mark played
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};
